import type { Page } from '../../types';

const lifeChances: Page[] = [
  {
    pageType: 'question',
    title: 'Going Forward Into Employment Pathways (previously known as Life Chances Schemes)',
    name: 'life-chances-page',
    hidePageTitle: true,
    description:
      'The Commission accredits and champions government employment initiatives through a specific exception in its Recruitment Principles - Exception 2: Support ' +
      'for government employment programmes. In these questions, we are asking about these.<br><br>' +
      'You can find more information about these schemes here:<br><br>' +
      '<a href="https://civilservicecommission.independent.gov.uk/recruitment/exceptions">https://civilservicecommission.independent.gov.uk/recruitment/exceptions</a> <br/>' +
      '<a href="https://www.civil-service-careers.gov.uk/gfie-pathways">https://www.civil-service-careers.gov.uk/gfie-pathways</a>',

    questions: [
      {
        questionType: 'radio',
        title: "Do you use any of the Commission accredited Exception 2 'Life Chances' schemes?",
        name: 'commission-accredited-exception2',
        options: ['Yes', 'No'],
        rules: {
          required: true,
        },
      },
    ],
  },
  {
    pageType: 'question',
    title: 'GFIE Pathways breakdown',
    name: 'life-chances-breakdown-page',
    description:
      'The Commission accredits and champions government employment initiatives through a specific exception in its Recruitment Principles - Exception 2: Support ' +
      'for government employment programmes. In these questions, we are asking about these.<br><br>' +
      'You can find more information about these schemes here:<br><br>' +
      '<a href="https://civilservicecommission.independent.gov.uk/recruitment/exceptions">https://civilservicecommission.independent.gov.uk/recruitment/exceptions</a> <br/>' +
      '<a href="https://www.civil-service-careers.gov.uk/gfie-pathways">https://www.civil-service-careers.gov.uk/gfie-pathways</a>',
    disabled: [
      {
        field: 'commission-accredited-exception2',
        condition: 'equals', // optional
        value: 'No',
      },
    ],
    questions: [
      {
        questionType: 'checkbox',
        title:
          "You have stated you use one (or more) of the Commission's Life Chances schemes. Please select which one/s you use from the following list:",
        name: 'life-chances-exception2-used-schemes',
        options: [
          'Autistic Hiring Programme (Ministry of Defence)',
          'Care Leavers Internship Pathway (Department for Education)',
          'Diversifying CPS Careers (Crown Prosecution Service)',
          'Enable pathway (Driver and Vehicle Licensing Agency)',
          'Employability in Scotland (Scottish Government)',
          'GFiE Pathway for Autistic People (Cabinet Office)',
          'Life Chance pathway for Carers (Cabinet Office)',
          'Life Chance pathway for Care Leavers (Cabinet Office)',
          'Life Chance pathway for People with Convictions (Cabinet Office)',
          'Life Chance pathway for Veterans and Military Spouses/Partners(Cabinet Office)',
          'MHCLG Civil Service Masterclass (Ministry of Housing Communities and Local Government)',
          'Modern Apprentice Pathway (Scottish Courts and Tribunal Service)',
          'Movement to Work Pathway (Department for Work and Pensions)',
          'Pathway to Employment (Department for Environment Food and Rural Affairs)',
          'Pathway to Employment (Home Office)',
          'Pathways to STEM Programme (Intellectual Property Office)',
          'Probation Employment Pathway (Ministry of Justice)',
          'Social Mobility Apprenticeship Programme (Department for Energy Security and Net Zero)',
          'Social Mobility Apprenticeship Programme (Department for Work and Pensions)',
          'Springboard (HM Revenue and Customs)',
          'Stepping into Communications (GCS Internship pathway) (Government Communication Service)',
          'Support for Care Leavers Pathway (Welsh Government)',
          'Supported Internships (Department for Education)',
          'WorkFit pathway (Department of Health and Social Care)',
          {
            option: 'Other',
            questions: [
              {
                questionType: 'textInput',
                title: 'Please specify',
                name: 'life-chances-exception2-used-schemes-other',
                rules: {
                  required: true,
                },
              },
              {
                questionType: 'textInput',
                title:
                  'Please provide contact details of the scheme lead/s (i.e. name and email address)',
                name: 'life-chances-contact-details',
                rules: {
                  required: true,
                },
              },
            ],
          },
        ],
        rules: {
          required: true,
        },
      },
    ],
  },
];
export default lifeChances;
